/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMlLogisticRegression = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M21.599 1.977c.15.004.27.01.355.016l.1.008.03.002.01.001h.003l.002.001-.198 1.99-.013-.002a7.516 7.516 0 0 0-.346-.018 11.024 11.024 0 0 0-1.038.022c-.871.058-2.01.232-3.133.68-1.117.448-2.194 1.158-2.995 2.28C13.579 8.072 13 9.673 13 12c0 2.673-.672 4.698-1.749 6.206-1.074 1.503-2.497 2.419-3.88 2.972-1.377.55-2.738.752-3.742.82a13.032 13.032 0 0 1-1.583.008l-.1-.007-.04-.004h-.005l.198-1.99.013.001.067.005a10.982 10.982 0 0 0 1.317-.009c.871-.058 2.01-.232 3.133-.68 1.117-.447 2.194-1.157 2.995-2.279C10.421 15.927 11 14.326 11 12c0-2.673.672-4.698 1.749-6.207 1.074-1.503 2.497-2.418 3.88-2.972 1.377-.55 2.738-.752 3.742-.819a13.03 13.03 0 0 1 1.228-.025zM16.5 15a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        <path d="M5.5 10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm13-5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-11-7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
      </g>
    </g>
  </Icon>
);
export { SvgMlLogisticRegression as MlLogisticRegression };
